module.exports = __webpack_public_path__ + "static/img/concaveVertical_Depth.b3bbb4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/curvedSurface/concaveVertical_Depth.png
// module id = 9Vgt
// module chunks = 3